// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"fbf4e7b3","534":"497c7c05"}[chunkId] + ".chunk.css";
};